import apiClient from "./index";
import {
  ContractorCreate,
  ContractorOut,
  ContractorTenantAccess,
  TenantOut,
} from "./types";

export const contractorsApi = {
  async listContractors(): Promise<ContractorOut[]> {
    const response = await apiClient.get<ContractorOut[]>("/admin/contractors");
    return response.data;
  },

  async createContractor(payload: ContractorCreate): Promise<ContractorOut> {
    const response = await apiClient.post<ContractorOut>("/admin/contractors", payload);
    return response.data;
  },

  async listTenants(): Promise<TenantOut[]> {
    const response = await apiClient.get<TenantOut[]>("/admin/tenants");
    return response.data;
  },
  async updateTenant(tenantId: string, data: Partial<TenantOut>): Promise<TenantOut> {
    const response = await apiClient.put<TenantOut>(`/admin/tenants/${tenantId}`, data);
    return response.data;
  },

  async listAccess(contractorUserId: string): Promise<ContractorTenantAccess[]> {
    const response = await apiClient.get<ContractorTenantAccess[]>(
      `/admin/contractor-access/${contractorUserId}`
    );
    return response.data;
  },

  async grantAccess(payload: ContractorTenantAccess): Promise<ContractorTenantAccess> {
    const response = await apiClient.post<ContractorTenantAccess>(
      "/admin/contractor-access",
      payload
    );
    return response.data;
  },

  async revokeAccess(contractorUserId: string, tenantId: string) {
    await apiClient.delete("/admin/contractor-access", {
      params: {
        contractor_user_id: contractorUserId,
        tenant_id: tenantId,
      },
    });
  },

  async listMyTenants(): Promise<ContractorTenantAccess[]> {
    const response = await apiClient.get<ContractorTenantAccess[]>(
      "/contractor/tenants"
    );
    return response.data;
  },
};
